module.exports = __webpack_public_path__ + "p8_img1.png?442bec9d1b4222d468102bce6d204726";


//////////////////
// WEBPACK FOOTER
// ./src/assets/p-imgs/p8/p8_img1.png
// module id = 61
// module chunks = 0